module.exports = __webpack_public_path__ + "img/organizational-unit.b4939625.svg";